// Native apps open the webview with ?ab_test=<value of the Firebase Remote Config key `prebooking_version`>.
// The param values are fixed by the apps; `tag` is what we send to GA4 and the datalake and changes per experiment.
export const AB_TEST_QUERY_PARAM = 'ab_test'
export const AB_TEST_TRACKING_KEY = 'experiment_variant'

export const AB_TEST_VARIANTS = {
  baseline: { tag: 'baseline_price_in_cta', hidePriceInCta: false },
  variant_a: { tag: 'variant_a_no_price_in_cta', hidePriceInCta: true },
} as const

export type AbTestParam = keyof typeof AB_TEST_VARIANTS

// Apps without consent or without a fetched config send no param (iOS) or `baseline` (Android).
export const DEFAULT_AB_TEST_PARAM: AbTestParam = 'baseline'

export function isAbTestParam(value: unknown): value is AbTestParam {
  return typeof value === 'string' && Object.hasOwn(AB_TEST_VARIANTS, value)
}

// The test only runs in the v3 funnel; the old webview flow shares components but stays on the baseline.
const V3_FUNNEL_PATH = /\/v3(?:\/|$)/

export function isV3FunnelPath(path: string | undefined): boolean {
  return V3_FUNNEL_PATH.test(path ?? '')
}
